import script from "./Mindmap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Mindmap.vue?vue&type=script&lang=ts&setup=true"

import "./Mindmap.vue?vue&type=style&index=0&id=04168770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04168770"]])

export default __exports__